import {
  ICampaignResponse,
  IProduct,
  deleteIsLockInIdServiceable,
  setIsLockInIdServiceable,
  BACKUP_OFFER_KEY,
} from '@vfit/consumer/data-access';
import { getFromLocalStorageByKey } from '@vfit/shared/data-access';
import { IBackupOffer, IOfferingServiceabilityResponse } from '@vfit/shared/models';
import { ICheckEligibility } from './coverageToolOtpCard.models';
import { ICheckLockin } from '../../coverageToolModal.models';
import { LOCKIN_ERROR_CODES } from '../../coverageToolModal.utils';

const checkLockInOffer = (product: IProduct, lockInProduct?: IProduct): ICheckLockin => {
  const offeringServiceability = getFromLocalStorageByKey('offeringServiceability');
  const allOfferingIds: string[] = offeringServiceability?.offeringServiceabilityItem?.map(
    (el: IBackupOffer) => el.offering.id
  );
  const alternativeOffers = product?.alternativeProductOfferList || [];
  if (lockInProduct) {
    let isLockInIdServiceable = false;
    if (alternativeOffers?.length > 0 && lockInProduct?.cmsId) {
      isLockInIdServiceable = alternativeOffers?.includes(lockInProduct?.cmsId?.toString());
    }
    if (isLockInIdServiceable) {
      const offeringServiceabilityItem = offeringServiceability?.offeringServiceabilityItem?.find(
        (el: IBackupOffer) => el.offering.id?.toString() === lockInProduct?.offerId?.toString()
      );
      localStorage.setItem(
        BACKUP_OFFER_KEY,
        JSON.stringify({
          offeringId: offeringServiceabilityItem?.offering?.id?.toString(),
          cmsId: lockInProduct?.cmsId?.toString(),
        })
      );
      setIsLockInIdServiceable();
      return ICheckLockin.GO_TO_OFFER;
    }
    return ICheckLockin.NO_COVERAGE;
  }
  deleteIsLockInIdServiceable();
  let isOfferFound = false;
  alternativeOffers?.forEach((el) => {
    if (allOfferingIds?.includes(el)) isOfferFound = true;
  });
  if (isOfferFound) {
    return ICheckLockin.GO_TO_OFFER;
  }
  return ICheckLockin.NO_OFFER_FOUND;
};

const checkCampaignEligibility = (
  offeringServiceability: IOfferingServiceabilityResponse,
  campaignsData: ICampaignResponse[]
): ICheckEligibility => {
  if (campaignsData && campaignsData.length <= 0) {
    return { eligible: false, errorCode: LOCKIN_ERROR_CODES.EMPTY_CAMPAIGNS_LIST };
  }
  const serviceabilityIds = offeringServiceability?.offeringServiceabilityItem?.map(
    (item) => item?.offering?.id
  );

  const fixedCampaignsList = campaignsData || [];

  if (fixedCampaignsList?.length === 0) {
    return { eligible: false, errorCode: LOCKIN_ERROR_CODES.EMPTY_CAMPAIGNS_LIST };
  }

  const usefulFixedCampaignsList: ICampaignResponse[] =
    fixedCampaignsList?.filter((item: ICampaignResponse) =>
      serviceabilityIds?.includes(item?.fixedBundle?.productOfferId)
    ) || [];

  if (usefulFixedCampaignsList?.length === 0) {
    return { eligible: false, errorCode: LOCKIN_ERROR_CODES.EMPTY_CAMPAIGNS_LIST };
  }
  const lockInOffersFound: ICampaignResponse[] = usefulFixedCampaignsList?.sort(
    (item1: ICampaignResponse, item2: ICampaignResponse) =>
      parseInt(item2.score, 10) - parseInt(item1.score, 10)
  );

  if (Object.keys(lockInOffersFound).length !== 0) {
    return { eligible: true, lockInOffer: lockInOffersFound[0], errorCode: '' };
  }
  return { eligible: false, errorCode: LOCKIN_ERROR_CODES.NO_USEFUL_CAMPAIGNS_FOUND };
};

const getEligibilityProduct = (allProducts: IProduct[], campaignsData: ICampaignResponse[]) => {
  const offeringServiceAbility: IOfferingServiceabilityResponse =
    getFromLocalStorageByKey('offeringServiceability');
  const campaignEligibility = checkCampaignEligibility(offeringServiceAbility, campaignsData);
  let lockInProduct;
  if (campaignEligibility?.lockInOffer?.fixedBundle?.productOfferId)
    lockInProduct = allProducts.find(
      (el) =>
        el.offerId.toString() ==
        campaignEligibility?.lockInOffer?.fixedBundle.productOfferId.toString()
    );
  return {
    campaignEligibility,
    lockInProduct,
  };
};

export { checkLockInOffer, LOCKIN_ERROR_CODES, getEligibilityProduct };
